import { MaxSizeValidator } from '@angular-material-components/file-input';
import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ICustomer } from 'app/models';
import { ICountry } from 'app/models/country.model';

import { CustomerService, ImageService } from 'app/services';
import { CountryService } from 'app/services/country/country.service';
import { MessageService } from 'app/services/message/message.service';


@Component({
  selector: 'app-customer-mngt-detail',
  templateUrl: './customer-mngt-detail.component.html',
  styleUrls: ['./customer-mngt-detail.component.scss']
})
export class CustomerMngtDetailComponent implements OnInit {

  @Output()
  customerSaved = new EventEmitter<boolean>();

  @Input()
  countries: ICountry[] = [];

  tmzs: any[] = [];

  imgaMaxSize = 2  ; //Mb

  customerForm: FormGroup = this.formBuilder.group({
    id: undefined,
    name: [null],
    address: [null],
    city: [null],
    email: [null],
    country: [null],
    timeZone: [null],
  }, {});

  constructor(
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
    private countryService: CountryService,
    private messageService: MessageService,
    private imageService: ImageService) { }

  ngOnInit(): void {
    this.initEmpty();
  }

  initEmpty() {
    this.customerForm = this.formBuilder.group({
      id: undefined,
      name: [null, Validators.required],
      address: [null, Validators.required],
      city: [null, Validators.required],
      email: [null, Validators.required],
      country: [null],
      timeZone: [null],
      imageBin: [null, MaxSizeValidator(this.imgaMaxSize * 2 ** 20 )],
      imageStr: [null],
      deleteImg: [false]
    });
  }

  initEdit(currentCustomer: ICustomer) {
    this.customerForm.setValue({
      id: currentCustomer.id,
      name: currentCustomer.name,
      address: currentCustomer.address,
      city: currentCustomer.city,
      email: currentCustomer.email,
      country: currentCustomer.country,
      timeZone: currentCustomer.timeZone,
      imageBin: null,
      imageStr: null,
      deleteImg: null
    });
    this. preapreTmz();
  }

  clear(): void {
    this.customerForm.reset();
  }

  preapreTmz(): void {
    this.tmzs = this.countryService.findTmzForCountry(this.customerForm.value.country);
  }

  async onSubmit() {
    if (!this.customerForm) {
      return;
    }
    if (this.customerForm.invalid) {
      return;
    }

    if (this.customerForm.value.imageBin) {
      await this.imageService.encodeB64(this.customerForm.value.imageBin).then((encodedValue) => {
        this.customerForm.patchValue({
          imageStr: encodedValue
        });
      });
    }

    if (this.customerForm.value.id) {
      this.customerService.updateCustomer(this.customerForm.value.id, this.customerForm.getRawValue()).subscribe((): void => {
        this.customerSaved.emit(true);
        this.clear();
      },
        () => this.messageService.showDirectSimpleMessage(` Customer save Error`)
      );
      return;
    }
    this.customerService.addCustomer(this.customerForm.getRawValue()).subscribe((): void => {
      this.customerSaved.emit(true);
      this.clear();
    },
      () => this.messageService.showDirectSimpleMessage(` Customer save Error`)
    );
  }


}


